"use client";
import { useEffect } from "react";

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export const useSessionTimeout = (logout, isAuthenticated) => {
  useEffect(() => {
    // Ensure it only runs in the browser
    if (typeof window === "undefined") return;

    if (!isAuthenticated) return;

    // --- STEP 1: Initial Session Check ---
    const lastActivity = localStorage.getItem("lastActivityTime");

    if (!lastActivity) {
      localStorage.setItem("lastActivityTime", Date.now().toString());
    } else {
      const elapsed = Date.now() - parseInt(lastActivity, 10);
      if (elapsed > SESSION_TIMEOUT) {
        logout();
        return;
      }
    }

    // --- STEP 2: Reset activity timer on interaction ---
    const updateActivity = () => {
      localStorage.setItem("lastActivityTime", Date.now().toString());
    };

    const activityEvents = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];

    activityEvents.forEach((ev) => {
      window.addEventListener(ev, updateActivity);
    });

    // --- STEP 3: Timer check every 1 minute ---
    const interval = setInterval(() => {
      const last = localStorage.getItem("lastActivityTime");
      if (!last) return;

      const elapsed = Date.now() - parseInt(last, 10);
      if (elapsed > SESSION_TIMEOUT) {
        logout();
      }
    }, 60 * 1000);

    // Cleanup to avoid memory leaks
    return () => {
      activityEvents.forEach((ev) => {
        window.removeEventListener(ev, updateActivity);
      });
      clearInterval(interval);
    };
  }, [isAuthenticated, logout]);
};
